var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5145_31055)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.364 3.40738C14.5514 3.59491 14.6568 3.84921 14.6568 4.11438C14.6568 4.37954 14.5514 4.63385 14.364 4.82138L6.86864 12.3167C6.76959 12.4158 6.65199 12.4944 6.52256 12.548C6.39313 12.6016 6.25441 12.6292 6.11431 12.6292C5.97421 12.6292 5.83549 12.6016 5.70606 12.548C5.57663 12.4944 5.45903 12.4158 5.35998 12.3167L1.63598 8.59338C1.54047 8.50113 1.46428 8.39079 1.41188 8.26878C1.35947 8.14678 1.33188 8.01556 1.33073 7.88278C1.32957 7.75 1.35487 7.61832 1.40516 7.49542C1.45544 7.37253 1.52969 7.26088 1.62358 7.16698C1.71747 7.07309 1.82913 6.99884 1.95202 6.94856C2.07492 6.89828 2.2066 6.87297 2.33938 6.87413C2.47216 6.87528 2.60338 6.90287 2.72538 6.95528C2.84738 7.00769 2.95773 7.08387 3.04998 7.17938L6.11398 10.2434L12.9493 3.40738C13.0422 3.31445 13.1524 3.24073 13.2738 3.19044C13.3952 3.14014 13.5253 3.11426 13.6566 3.11426C13.788 3.11426 13.9181 3.14014 14.0395 3.19044C14.1608 3.24073 14.2711 3.31445 14.364 3.40738Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5145_31055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/RightIcon.0cafa69974b654fb84bf23501bfbe0e8.svg";
export { ForwardRef as ReactComponent };